var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table-grid',{ref:"tableGrid",attrs:{"search-table":"","headers":_vm.headers,"items":_vm.resources,"loading":_vm.loading,"multiple":true,"noPagination":true,"itemsPerPage":_vm.pagination.limit,"page":_vm.pagination.page,"pageLength":_vm.lengthPaginationComp},on:{"select":_vm.selectResource,"change-page":_vm.changePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }